<div class="p-d-flex p-ai-center p-jc-center" [style]="{height: height}">
    <p-progressSpinner [style]="{width: '50px', height: '50px'}" styleClass="custom-spinner" animationDuration=".5s"></p-progressSpinner>
</div>
